// extracted by mini-css-extract-plugin
export default {"card":"CX-z","carouselContainer":"DX-z","carouselContent":"EX-z"};